import React from 'react';
import './ErrorHandler.css';

const errorHandler = (props) => {
    return(
        <div className="error-container">
            <p>{props.message}</p>
            <span onClick={props.closeHandler}>Ok</span>
        </div>
    )
}

export default errorHandler;